import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAttachments } from "./AttachmentContext";

export default function AttachmentDeleteModal() {
    const { 
        deleteModalOpen, 
        setDeleteModalOpen, 
        attachmentToDelete, 
        setAttachmentToDelete,
        handleDeleteAttachment, 
        isDeleting,
        newTask 
    } = useAttachments();

    const handleDelete = async () => {
        if (attachmentToDelete) {
            await handleDeleteAttachment(attachmentToDelete);
        }
    };

    const handleClose = () => {
        setDeleteModalOpen(false);
        setAttachmentToDelete(null);
    };

    return (
        <Dialog open={deleteModalOpen} onOpenChange={setDeleteModalOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{newTask ? 'Remove' : 'Delete'} Attachment</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to {newTask ? 'remove' : 'delete'} this attachment?
                        {" If this image or file is used in the task description, it will also be removed from there."}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleDelete}
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deleting...' : (newTask ? 'Remove' : 'Delete')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
} 